import { Component } from 'preact'
import likePostRequest from 'utils/likePostRequest'
import Icon from '../assets/'
import { t } from '../../libs/translationsUtils/translations'
import { common } from '../common'

export default class TopicListLikeButton extends Component {
  constructor (props) {
    super(props)

    this.state = {
      hasCurrentUserLiked: props.topic.hasCurrentUserLiked,
      numberOfLikes: props.topic.numberOfLikes
    }

    this.likeTopicHandler = this.likeTopicHandler.bind(this)
  }

  likeTopicHandler () {
    const { isGuest, topic } = this.props
    const { id } = topic.firstPost
    const { hasCurrentUserLiked, numberOfLikes } = this.state

    if (isGuest) {
      // eslint-disable-next-line no-undef
      const event = new CustomEvent('GuestUserAction')

      return window.dispatchEvent(event)
    }

    this.setState({
      hasCurrentUserLiked: !hasCurrentUserLiked,
      numberOfLikes: parseInt(numberOfLikes, 10) + (!hasCurrentUserLiked ? 1 : -1)
    })

    likePostRequest(topic.id, id, !hasCurrentUserLiked, (err) => {
      if (err) {
        this.setState({
          hasCurrentUserLiked: !hasCurrentUserLiked,
          numberOfLikes: parseInt(numberOfLikes, 10) + (!hasCurrentUserLiked ? 1 : -1)
        })
        console.error(err)
      }
    })
  }

  render (props, state) {
    const isNewTopicListViewEnabled = common.isModuleActive('topicItemView')
    const { isIdeation } = props.topic.forum
    const { hasCurrentUserLiked, numberOfLikes } = state
    let likeBtnClass = 'thread-meta-item thread-meta-item--hover-highlight thread-meta-item--likes qa-topic-meta-likes-icon'
    let voteBtnClass = 'thread-meta-item btn--toggle thread-meta-item--vote qa-topic-meta-likes-icon'

    if (hasCurrentUserLiked) {
      likeBtnClass += ' thread-meta-item--likes--liked'
      voteBtnClass += ' preact_voted'
    }

    return (
      !isIdeation ? (
        <button class={likeBtnClass} onClick={this.likeTopicHandler} type='button'>
          <i class='thread-meta-item__icon icon--auto-width icon--thumb-up' />
          <span class='thread-meta-item__text js-vote-count qa-topic-meta-likes-content'>
            {numberOfLikes}
          </span>
        </button>
      ) : (
        isNewTopicListViewEnabled ? (
          <button className={voteBtnClass} onClick={this.likeTopicHandler}>
            <span className='qa-topic-meta-likes-content'>{numberOfLikes}</span>
            <Icon
              icon='triangle'
              width={10}
              height={8}
            />
          </button>
        ) : (
          <button className={voteBtnClass} onClick={this.likeTopicHandler} type='button'>
            {
              hasCurrentUserLiked ? (
                <span
                  className='thread-meta-item__text--voted voted preact_voted-button'>
                  { t('Forum', 'topicList.meta.voted') }
                </span>
              ) : (
                <span className='thread-meta-item__text--vote'>
                  { t('Forum', 'topicList.meta.vote') }
                </span>
              )
            }
            <span className='qa-topic-meta-likes-content'>{numberOfLikes}</span>
          </button>
        )
      )
    )
  }
}
